import { render } from "./LabDashboard.vue?vue&type=template&id=564cc908&scoped=true"
import script from "./LabDashboard.vue?vue&type=script&lang=js"
export * from "./LabDashboard.vue?vue&type=script&lang=js"

import "./LabDashboard.vue?vue&type=style&index=0&id=564cc908&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564cc908"]])

export default __exports__